import * as React from "react";
import icon from "../../../UI/general/Icono.svg";
import POI from "../../../UI/general/PDI.svg";
import VIA from "../../../UI/general/Vias.svg";
import IIMG from "../../../UI/general/Image.svg";
import WORLD from "../../../UI/general/world.svg";
import { log } from "aframe";
import {
  FormControl,
  FormControlLabel,
  InputBase,
  InputLabel,
  NativeSelect,
  Switch,
  SwitchProps,
  styled,
} from "@mui/material";
import { rotate } from "ol/transform";
declare const window: any;

const SwitchDisponible = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#65C466",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#C6C6C6",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #65C466",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16,
    height: 16,
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
const SwitchNoDisponible = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#000",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#C6C6C6",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #000",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16,
    height: 16,
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
const SwitchVendido = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#FF0000",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#C6C6C6",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #FF0000",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16,
    height: 16,
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
const SwitchReservado = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#EEA63A",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#C6C6C6",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #EEA63A",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16,
    height: 16,
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

/* const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 12,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
})); */

export default function SideBarContainer({
  data,
  location,
  setisMapRenderVIAS,
  setIsMapFoto360POIS,
  isMapRenderVIAS,
  isMapFoto360POIS,
  isPortrait,
  setIsSelectedPOI,
  setIsSelectedVIA,
  isSelectedPOI,
  isSelectedVIA,
  original,
  setSpinSelected,
  setGaleriaSelected,
  setOriginalGleriaSelected,
  setSubMenuSelected,
  subMenuSelectedTemp,
  setMenuSelected,
  subMenuSelected,
  theme,
  isSideBar,
  setIsSideBar,
  menuSelected,
  icono,
  isSelected,
  setIsSelected,
  isSelectedAmenitiesAttributes,
  setIsSelectedAmenitiesAttributes,
  colors,
  setIsSelectedAttribute,
  setCurrentSelectedAttribute,
  isSelectedAttribute,
  setSelectAvailability,
  selectAvailability,
  setFrame,
  setIsAnimationAmenites,
  amenities_hierarchical,
  setIsAnimationAttribute,
  setIsSelectedAmenitiesView,
  isSelectedAmenitiesView,
  hotspotsSelected,
  setHotspotsSelected,
  version,
}: any) {
  const [isSelectedGallerieGroup, setIsSelectedGallerieGroup] =
    React.useState("");
  const [isSelectedLocationGroup, setIsSelectedLocationGroup] =
    React.useState("");
  const [isSelectedPropertiesGroup, setIsSelectedPropertiesGroup] =
    React.useState("");
  const [isDragging, setIsDragging] = React.useState(false);
  const [startX, setStartX] = React.useState(0);
  const [startXOther, setStartXOther]: any = React.useState(0);
  const [isSelectedModulAttribute, setIsSelectedModulAttribute]: any =
    React.useState({
      disponibilidad: true,
      filtros: true,
    });
  const [
    isSelectedAmenityAttributeIndividual,
    setIsSelectedAmenityAttributeIndividual,
  ]: any = React.useState("");

  /* const [age, setAge] = React.useState("");
  const handleChange = (event: { target: { value: string } }) => {
    setAge(event.target.value);
  }; */

  const handleAddDown = (val) => {
    var sidebarOriginal: any = document.querySelector(
      ".sidebar-container-portrait"
    );
    if (val) {
      sidebarOriginal.classList.remove("down");
      sidebarOriginal.classList.add("animation");
    } else {
      sidebarOriginal.classList.remove("animation");
      sidebarOriginal.classList.add("down");
    }
    var sidebar: any = document.querySelector(
      ".sidebar-container-portrait.down"
    );
    var sidebarInternal: any = document.querySelector(
      ".sidebar-container-portrait-internal"
    );

    if (sidebar) {
      if (
        (Array.isArray(data) && data.find((e) => e.id === isSelected))?.id ||
        (original && original.find((e) => e.name === isSelectedGallerieGroup))
          ?.name ||
        isSelectedLocationGroup !== ""
      ) {
        sidebar.style.bottom = -sidebarInternal.offsetHeight + 14 + "px";
      } else if (menuSelected === "Inmuebles") {
        sidebar.style.bottom = -sidebarInternal.offsetHeight + 14 + "px";
      } else {
        sidebar.style.bottom = -sidebarInternal.offsetHeight + 14 + "px";
      }
    } else {
      sidebarOriginal.style.removeProperty("bottom");
    }
  };

  React.useEffect(() => {
    if (menuSelected === "Inmuebles" && subMenuSelected !== "Galería") {
      let temp: Record<string, any[]> = {};

      // Dejamos los objetos completos
      const normalizedHotspots = hotspotsSelected?.hierarchicals || [];

      //console.log("normalizedHotspots:", normalizedHotspots);

      data?.properties?.attributes?.forEach((element) => {
        if (element.active && element.name) {
          if (!temp[element.name]) {
            temp[element.name] = []; // inicializa como array vacío
          }

          // Filtramos manteniendo el objeto completo de element.values
          const matchingValues =
            element?.values?.filter((e) =>
              normalizedHotspots.some((h) => h.hierarchicals_name === e.value)
            ) || [];

          if (matchingValues.length > 0) {
            temp[element.name].push(...matchingValues); // Guarda objetos completos
          }
        }
      });

      //console.log("temp:", temp);
      setIsSelectedAttribute(temp);
    }
  }, [menuSelected]);

  // ---- Scroll helpers / refs: pegar aquí (una sola vez) ----
  const amenityRefs = React.useRef<Record<string, HTMLDivElement | null>>({});
  const attributeRefs = React.useRef<Record<string, HTMLDivElement | null>>({});

  const scrollElementIntoSidebar = (el: HTMLElement | null) => {
    if (!el) return;

    const container = document.querySelector(
      ".sidebar-internal-container .sidebar-internal-container-menus"
    ) as HTMLElement | null;

    if (!container) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    const offset = elRect.top - containerRect.top;

    container.scrollTo({
      top: container.scrollTop + offset - 8, // padding opcional
      behavior: "smooth",
    });
  };

  React.useEffect(() => {
    if (menuSelected !== "Amenidades") return;

    requestAnimationFrame(() => {
      if (
        amenities_hierarchical === 1 &&
        isSelectedAmenityAttributeIndividual
      ) {
        const attrEl =
          attributeRefs.current[isSelectedAmenityAttributeIndividual];
        if (attrEl) {
          scrollElementIntoSidebar(attrEl);
          return;
        }
      }

      if (isSelected) {
        const amenEl = amenityRefs.current[isSelected];
        if (amenEl) {
          scrollElementIntoSidebar(amenEl);
          return;
        }
      }
    });
  }, [
    isSelected,
    isSelectedAmenityAttributeIndividual,
    amenities_hierarchical,
    menuSelected,
    subMenuSelected,
  ]);

  // Verifica si un valor es válido para un filtro dado
  const isValidateFilter = (AtValue, currentFilterName) => {
    const filteredProps = getFilteredProperties();

    // Buscamos si al menos una propiedad filtrada contiene el valor actual
    return filteredProps.some((prop) =>
      prop.values.some((v) => v.IdValue === AtValue.id)
    );
  };

  // Igual pero con el caso especial de hotspots
  const isValidateFilterAttribute = (AtValue) => {
    const normalizedSubMenuSelected =
      hotspotsSelected?.hierarchicals?.map((item) => item.hierarchicals_name) ||
      [];

    const filteredProps = getFilteredProperties();

    return filteredProps.some((element) => {
      const matchAtValue = element.values.some(
        (v) => v.value === AtValue.value
      );
      const matchHotspot = element.values.some((v) =>
        normalizedSubMenuSelected.includes(v.value)
      );
      return matchAtValue && matchHotspot;
    });
  };

  // Obtiene las propiedades que cumplen TODAS las selecciones actuales
  const getFilteredProperties = () => {
    return (data?.properties?.property || []).filter((property) =>
      Object.entries(isSelectedAttribute).every(
        ([filterName, selectedValues]: any) => {
          if (!selectedValues || selectedValues.length === 0) return true;
          return property.values.some(
            (v) =>
              selectedValues.includes(v.value) ||
              selectedValues.some((s) => s.value === v.value)
          );
        }
      )
    );
  };

  const darkenColor = (color, percent) => {
    const f = parseInt(color.slice(1), 16);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    return (
      "#" +
      (
        0x1000000 +
        (Math.round((t - R) * p) + R) * 0x10000 +
        (Math.round((t - G) * p) + G) * 0x100 +
        (Math.round((t - B) * p) + B)
      )
        .toString(16)
        .slice(1)
    );
  };

  // Calcular validaciones con useMemo fuera del mapeo
  const memoizedValidations = React.useMemo(() => {
    if (!data?.properties?.attributes) return [];

    return data.properties.attributes.map((row) => ({
      row,
      validations: row?.values?.map((subRow) => ({
        subRow,
        isValidFilter: isValidateFilter(subRow, row.name),
        isValidFilterAttribute: isValidateFilterAttribute(subRow),
      })),
    }));
  }, [data, isSelectedAttribute, subMenuSelected]);

  const getButtonStyle = (
    row,
    subRow,
    subInd,
    colors,
    isSelectedAttribute,
    isValid
  ) => {
    const current = isSelectedAttribute[row.name] || [];
    const isSelected = current.some(
      (item) => item?.value === subRow.value || item === subRow.value
    );

    const isMobile =
      !window.functionIsPortrait() && window.functionIsMobileDevice();

    let style = {
      backgroundColor: isSelected ? colors?.main_buttons : "",
      color: isSelected ? "#fff" : "",
      pointerEvents: isValid ? "auto" : "none",
      opacity: isValid ? "1" : "0.5",
      cursor: isValid ? "pointer" : "none",
    };

    if (subRow.value.length < 3) {
      style = {
        ...style,
        maxWidth: isMobile ? "1.5625rem" : "2rem",
        width: isMobile ? "1.5625rem" : "2rem",
        height: isMobile ? "1.0625rem" : "1.875rem",
        maxHeight: isMobile ? "1.0625rem" : "1.875rem",
        marginLeft: isMobile ? "0.375rem" : "0.625rem",
        marginRight:
          isMobile && subInd === row?.values?.length
            ? "0.375rem !important"
            : "",
      };
    } else if (subRow.value.length < 12) {
      style = {
        ...style,
        maxWidth: isMobile ? "3.5625rem" : "5.2rem",
        width: isMobile ? "3.5625rem" : "5.2rem",
        height: isMobile ? "1.0625rem" : "1.875rem",
        maxHeight: isMobile ? "1.0625rem" : "1.875rem",
        marginLeft: isMobile ? "0.375rem" : "0.625rem",
        marginRight:
          isMobile && subInd === row?.values?.length
            ? "0.375rem !important"
            : "",
      };
    } else {
      style = {
        ...style,
        maxWidth: isMobile ? "3.5625rem" : "10.8125rem",
        width: isMobile ? "3.5625rem" : "10.8125rem",
        height: isMobile ? "1.0625rem" : "1.875rem",
        maxHeight: isMobile ? "1.0625rem" : "1.875rem",
        marginLeft: isMobile ? "0.375rem" : "0.625rem",
        marginRight:
          isMobile && subInd === row?.values?.length
            ? "0.375rem !important"
            : "",
      };
    }

    return style;
  };

  //console.log(data?.properties?.attributes);
  //console.log(isSelectedAttribute);

  /* console.log(menuSelected);
  console.log(subMenuSelected);
  console.log(subMenuSelectedTemp); */

  return !isPortrait ? (
    <div className={`sidebar-container ${isSideBar ? "show" : ""}`}>
      <div className={`sidebar-internal-container ${theme} ${menuSelected}`}>
        <div className="sidebar-internal-container-close">
          <div
            className="setting-boton-circular"
            onClick={() => {
              setGaleriaSelected([]);

              if (
                menuSelected === "Inmuebles" &&
                subMenuSelected === "Galería"
              ) {
                setSubMenuSelected(subMenuSelectedTemp);
              } else if (
                menuSelected !== "Galería" &&
                menuSelected !== "Inmuebles" &&
                subMenuSelected === "Galería"
              ) {
                setSubMenuSelected("");
                setHotspotsSelected(null);
              } else {
                setMenuSelected("");
                setSubMenuSelected("");
                setHotspotsSelected(null);
              }

              // setFrame(1);
            }}
          >
            <i className="fas fa-xmark"></i>
          </div>
        </div>
        <div className="sidebar-internal-container-logo">
          <img
            src={
              version < "2.1.0"
                ? icono.icono
                : `${
                    window.hybrid
                      ? "./"
                      : "https://d1bsymnertnea6.cloudfront.net"
                  }${icono.icono}`
            }
            alt=""
          />
          <div className="sidebar-internal-container-title">
            {subMenuSelected === "Galería" ? subMenuSelected : (icono?.label ? icono.label : icono?.name)}
          </div>
        </div>
        <div></div>
        {menuSelected === "Galería" &&
        subMenuSelected !== "" &&
        subMenuSelected !== "Galería" ? (
          <div className="sidebar-internal-container-breadcrum">
            <div
              className="sidebar-internal-container-breadcrum-inactive"
              onClick={() => {
                setIsSelected("");
                setSubMenuSelected("Galería");
                setGaleriaSelected(original);
              }}
            >
              {menuSelected}
            </div>{" "}
            <i className="fa-solid fa-caret-right"></i>{" "}
            <div
              className="sidebar-internal-container-breadcrum-active"
              style={{ backgroundColor: colors?.main_buttons }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = darkenColor(
                  colors?.main_buttons,
                  -0.2
                );
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = colors?.main_buttons;
              }}
            >
              {subMenuSelected}
            </div>
          </div>
        ) : null}
        {menuSelected !== "Galería" && subMenuSelected === "Galería" ? (
          <div>{`/${menuSelected}`}</div>
        ) : null}
        <div
          className={`sidebar-internal-container-menus ${
            menuSelected === "Galería" && subMenuSelected === "Galería"
              ? "folder"
              : ""
          }`}
        >
          {menuSelected === "Urbanismo" && subMenuSelected === "" ? (
            <>
              {/* Item fijo adicional */}
              {location !== null ? <div
                className="sidebar-internal-container-menus-item"
                /* onClick={() =>
                  setIsSelected(isSelected === "FOTO_360" ? "" : "FOTO_360")
                } */
                onClick={() => {
                  setMenuSelected("Ubicación"),
                    setisMapRenderVIAS(false),
                    setIsMapFoto360POIS(!isMapFoto360POIS),
                    setIsSelectedVIA([]),
                    setIsSelectedPOI([]);
                }}
                style={
                  isSelected === "FOTO_360"
                    ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                      }
                    : {}
                }
                data-type="URBANISMO"
                data-value="FOTO_360"
              >
                <div
                  style={
                    isSelected === "FOTO_360"
                      ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                      : {}
                  }
                  onClick={() => {
                    setMenuSelected("Ubicación"),
                      setisMapRenderVIAS(false),
                      setIsMapFoto360POIS(!isMapFoto360POIS),
                      setIsSelectedVIA([]),
                      setIsSelectedPOI([]);
                  }}
                >
                  <img
                    src={WORLD}
                    alt=""
                    style={
                      isSelected === "FOTO_360"
                        ? { filter: "invert(1) brightness(100%)" }
                        : {}
                    }
                  />{" "}
                  Foto aérea 360°
                </div>
              </div> : null}
              {data
                .sort((a, b) =>
                  !a.hierarchicalLevel
                    ? 1
                    : !b.hierarchicalLevel
                    ? -1
                    : parseInt(b.hierarchicalLevel.split("#")[1]) -
                      parseInt(a.hierarchicalLevel.split("#")[1])
                )
                ?.map((row) =>
                  row.type === "Hierarchical" ? (
                    <div
                      key={row.name}
                      className="sidebar-internal-container-menus-item"
                      onClick={() =>
                        setIsSelected(isSelected === row.name ? "" : row.name)
                      }
                      style={
                        isSelected === row.name
                          ? {
                              backgroundColor: colors?.main_buttons,
                              color: "#fff",
                            }
                          : {}
                      }
                      data-type="URBANISMO"
                      data-value={row.name.toUpperCase()}
                    >
                      <div
                        style={
                          isSelected === row.name
                            ? {
                                backgroundColor: colors?.main_buttons,
                                color: "#fff",
                              }
                            : {}
                        }
                        data-type="URBANISMO"
                        data-value={row.name.toUpperCase()}
                      >
                        <img
                          src={icon}
                          alt=""
                          data-type="URBANISMO"
                          data-value={row.name.toUpperCase()}
                          style={
                            isSelected === row.name
                              ? { filter: "invert(1) brightness(100%)" }
                              : {}
                          }
                        />{" "}
                        {row.name}
                      </div>
                    </div>
                  ) : null
                )}
            </>
          ) : menuSelected === "Ubicación" ? (
            <>
              {/* <div>
                    {data?.address}
                  </div>
                  <div>
                    {data?.city}
                  </div> */}
              {data?.routes?.length > 0 ||
              data?.mapa_ilustrado_vias !== null ? (
                <div className="sidebar-internal-container-options-location">
                  <div className="sidebar-internal-container-options-location-title">
                    <img src={VIA} alt="" />
                    Vías de Acceso
                  </div>
                  {data?.mapa_ilustrado_vias !== null ||
                  data?.mapa_vias_foto_360 !== null ? (
                    <div className="sidebar-internal-container-options-location-adicional">
                      <div className="sidebar-internal-container-options-location-adicional-title">
                        INFORMACIÓN ADICIONAL
                      </div>
                      {data?.mapa_vias_foto_360 !== null ? (
                        <div
                          className="sidebar-internal-container-options-location-adicional-item"
                          style={
                            isMapFoto360POIS
                              ? {
                                  backgroundColor: colors?.main_buttons,
                                  color: "#fff",
                                }
                              : {}
                          }
                          onClick={() => {
                            setisMapRenderVIAS(false),
                              setIsMapFoto360POIS(!isMapFoto360POIS),
                              setIsSelectedVIA([]),
                              setIsSelectedPOI([]);
                          }}
                        >
                          <img
                            src={WORLD}
                            style={
                              isMapFoto360POIS
                                ? {
                                    filter: `invert(1) brightness(100%)`,
                                  }
                                : {}
                            }
                            alt=""
                          />
                          Foto aérea 360°
                        </div>
                      ) : null}
                      {data?.mapa_ilustrado_vias !== null ? (
                        <div
                          className="sidebar-internal-container-options-location-adicional-item"
                          style={
                            isMapRenderVIAS
                              ? {
                                  backgroundColor: colors?.main_buttons,
                                  color: "#fff",
                                }
                              : {}
                          }
                          onClick={() => {
                            setisMapRenderVIAS(!isMapRenderVIAS),
                              setIsMapFoto360POIS(false),
                              setIsSelectedVIA([]),
                              setIsSelectedPOI([]);
                          }}
                        >
                          <img
                            src={IIMG}
                            style={
                              isMapRenderVIAS
                                ? {
                                    filter: `invert(1) brightness(100%)`,
                                  }
                                : {}
                            }
                            alt=""
                          />
                          Mapa ilustrado
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  <div
                    className="sidebar-internal-container-options-location-poi"
                    onClick={() => {
                      setIsSelectedVIA(data?.routes),
                        setIsSelectedPOI([]),
                        setisMapRenderVIAS(false);
                      setIsMapFoto360POIS(false);
                    }}
                    style={
                      isSelectedVIA.length > 1
                        ? {
                            backgroundColor: colors?.main_buttons,
                            color: "#fff",
                          }
                        : {}
                    }
                  >
                    <img
                      src={icon}
                      style={
                        isSelectedVIA.length > 1
                          ? { filter: "invert(1) brightness(100%)" }
                          : {}
                      }
                      alt=""
                    />
                    <span>Ver todos</span>
                  </div>
                  {data?.routes?.length > 0
                    ? data?.routes
                        ?.sort((a, b) => a.indice - b.indice)
                        .map((e) => (
                          <div
                            className="sidebar-internal-container-options-location-poi"
                            style={
                              isSelectedVIA.length === 1 &&
                              isSelectedVIA[0]?.name === e.name
                                ? {
                                    backgroundColor: colors?.main_buttons,
                                    color: "#fff",
                                  }
                                : {}
                            }
                            onClick={() => {
                              setIsSelectedVIA(
                                isSelectedVIA.length === 1 &&
                                  isSelectedVIA[0]?.name === e.name
                                  ? []
                                  : [e]
                              ),
                                setIsSelectedPOI([]);
                              setisMapRenderVIAS(false);
                              setIsMapFoto360POIS(false);
                            }}
                            data-type={"UBICACION"}
                            data-value={"VIA"}
                            data-second={e.name.toUpperCase()}
                          >
                            <div
                              style={{ backgroundColor: e.color }}
                              data-type={"UBICACION"}
                              data-value={"VIA"}
                              data-second={e.name.toUpperCase()}
                            ></div>
                            <span
                              data-type={"UBICACION"}
                              data-value={"VIA"}
                              data-second={e.name.toUpperCase()}
                            >
                              {e.name}
                            </span>
                          </div>
                        ))
                    : null}
                </div>
              ) : null}
              {data?.POIS?.length > 0 || data?.mapa_ilustrado_pois !== null ? (
                <div className="sidebar-internal-container-options-location">
                  <div className="sidebar-internal-container-options-location-title">
                    <img src={POI} alt="" />
                    Puntos de interés
                  </div>
                  {data?.mapa_ilustrado_pois !== null ||
                  data?.mapa_pois_foto_360 ? (
                    <div className="sidebar-internal-container-options-location-adicional">
                      <div className="sidebar-internal-container-options-location-adicional-title">
                        INFORMACIÓN ADICIONAL
                      </div>
                      {data?.mapa_pois_foto_360 ? (
                        <div
                          className="sidebar-internal-container-options-location-adicional-item"
                          style={
                            isMapFoto360POIS
                              ? {
                                  backgroundColor: colors?.main_buttons,
                                  color: "#fff",
                                }
                              : {}
                          }
                          onClick={() => {
                            setisMapRenderVIAS(false),
                              setIsMapFoto360POIS(!isMapFoto360POIS),
                              setIsSelectedVIA([]),
                              setIsSelectedPOI([]);
                          }}
                        >
                          <img
                            src={WORLD}
                            style={
                              isMapFoto360POIS
                                ? {
                                    filter: `invert(1) brightness(100%)`,
                                  }
                                : {}
                            }
                            alt=""
                          />
                          Foto aérea 360°
                        </div>
                      ) : null}
                      {data?.mapa_ilustrado_pois !== null ? (
                        <div className="sidebar-internal-container-options-location-adicional-item">
                          <img src={IIMG} alt="" />
                          Mapa ilustrado
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  <div
                    className="sidebar-internal-container-options-location-poi"
                    onClick={() => {
                      setIsSelectedPOI(
                        isSelectedPOI.length.length > 0 ? [] : data?.POIS
                      ),
                        setIsSelectedVIA([]);
                      setisMapRenderVIAS(false);
                      setIsMapFoto360POIS(false);
                    }}
                    style={
                      isSelectedPOI.length > 1
                        ? {
                            backgroundColor: colors?.main_buttons,
                            color: "#fff",
                          }
                        : {}
                    }
                  >
                    <img
                      src={icon}
                      style={
                        isSelectedPOI.length > 1
                          ? { filter: "invert(1) brightness(100%)" }
                          : {}
                      }
                      alt=""
                    />
                    <span>Ver todos</span>
                  </div>
                  {data?.POIS?.length > 0
                    ? data?.POIS?.sort((a, b) => a.indice - b.indice).map(
                        (e) => (
                          <div
                            className="sidebar-internal-container-options-location-poi"
                            style={
                              isSelectedPOI.length === 1 &&
                              isSelectedPOI[0]?.category === e.category
                                ? {
                                    backgroundColor: colors?.main_buttons,
                                    color: "#fff",
                                  }
                                : {}
                            }
                            onClick={() => {
                              setIsSelectedPOI(
                                isSelectedPOI.length === 1 &&
                                  isSelectedPOI[0]?.category === e.category
                                  ? []
                                  : [e]
                              ),
                                setIsSelectedVIA([]);
                              setisMapRenderVIAS(false);
                              setIsMapFoto360POIS(false);
                            }}
                            data-type={"UBICACION"}
                            data-value={"POI"}
                            data-second={e.category.toUpperCase()}
                          >
                            <img
                              style={
                                isSelectedPOI.length === 1 &&
                                isSelectedPOI[0]?.category === e.category
                                  ? { filter: "invert(1) brightness(100%)" }
                                  : {}
                              }
                              src={
                                (window.hybrid
                                  ? "./"
                                  : "https://d1bsymnertnea6.cloudfront.net/") +
                                e.icon
                              }
                              data-type={"UBICACION"}
                              data-value={"POI"}
                              data-second={e.category.toUpperCase()}
                            />
                            <span
                              data-type={"UBICACION"}
                              data-value={"POI"}
                              data-second={e.category.toUpperCase()}
                            >
                              {e.category}
                            </span>
                          </div>
                        )
                      )
                    : null}
                </div>
              ) : null}
            </>
          ) : menuSelected === "Inmuebles" && subMenuSelected === "" ? (
            <>
              {data?.properties?.disponibilidad ? (
                <div
                  className={`sidebar-internal-container-menus-availability ${
                    isSelectedModulAttribute.disponibilidad ? "" : "collapse"
                  }`}
                >
                  <div
                    className="sidebar-internal-container-menus-availability-title"
                    onClick={() =>
                      setIsSelectedModulAttribute({
                        ...isSelectedModulAttribute,
                        disponibilidad:
                          !isSelectedModulAttribute.disponibilidad,
                      })
                    }
                  >
                    DISPONIBILIDAD
                    <i
                      style={{
                        transform: isSelectedModulAttribute.disponibilidad
                          ? "rotate(90deg)"
                          : "rotate(0deg)",
                      }}
                      className={`fa fa-chevron-right`}
                    ></i>
                  </div>
                  {/* {isSelectedModulAttribute.disponibilidad ? (
                    <> */}
                  {data?.state_disponible ? (
                    <div className="sidebar-internal-container-menus-availability-sw">
                      <FormControlLabel
                        control={
                          <SwitchDisponible sx={{ m: 0.5 }} defaultChecked />
                        }
                        label=""
                        style={{ marginLeft: "0.2rem" }}
                        onChange={(e: any) =>
                          setSelectAvailability({
                            ...selectAvailability,
                            DISPONIBLE: e.target.checked,
                          })
                        }
                      />
                      <span>Disponible</span>
                    </div>
                  ) : null}{" "}
                  {data?.state_vendido === 1 ? (
                    <div className="sidebar-internal-container-menus-availability-sw">
                      <FormControlLabel
                        control={
                          <SwitchVendido sx={{ m: 0.5 }} defaultChecked />
                        }
                        label=""
                        style={{ marginLeft: "0.2rem" }}
                        onChange={(e: any) =>
                          setSelectAvailability({
                            ...selectAvailability,
                            VENDIDO: e.target.checked,
                          })
                        }
                      />
                      <span>Vendido</span>
                    </div>
                  ) : null}{" "}
                  {data?.state_no_disponible ? (
                    <div className="sidebar-internal-container-menus-availability-sw">
                      <FormControlLabel
                        control={
                          <SwitchNoDisponible sx={{ m: 0.5 }} defaultChecked />
                        }
                        label=""
                        style={{ marginLeft: "0.2rem" }}
                        onChange={(e: any) =>
                          setSelectAvailability({
                            ...selectAvailability,
                            "NO DISPONIBLE": e.target.checked,
                          })
                        }
                      />
                      <span>No Disponible</span>
                    </div>
                  ) : null}{" "}
                  {data?.state_reservado === 1 ? (
                    <div className="sidebar-internal-container-menus-availability-sw">
                      <FormControlLabel
                        control={
                          <SwitchReservado sx={{ m: 0.5 }} defaultChecked />
                        }
                        label=""
                        style={{ marginLeft: "0.2rem" }}
                        onChange={(e: any) =>
                          setSelectAvailability({
                            ...selectAvailability,
                            RESERVADO: e.target.checked,
                          })
                        }
                      />
                      <span>Reservado</span>
                    </div>
                  ) : null}
                  {/* </>
                  ) : null} */}
                </div>
              ) : null}
              <div
                className={`sidebar-internal-container-menus-attributes ${
                  isSelectedModulAttribute.filtros ? "" : "collapse"
                }`}
              >
                <div
                  className="sidebar-internal-container-menus-attributes-title"
                  onClick={() =>
                    setIsSelectedModulAttribute({
                      ...isSelectedModulAttribute,
                      filtros: !isSelectedModulAttribute.filtros,
                    })
                  }
                >
                  FILTRAR POR ATRIBUTOS
                  <i
                    style={{
                      transform: isSelectedModulAttribute.filtros
                        ? "rotate(90deg)"
                        : "rotate(0deg)",
                    }}
                    className={`fa fa-chevron-right`}
                  ></i>
                </div>
                {data?.properties?.attributes
                  .sort((a, b) =>
                    a.indice === null
                      ? 1
                      : b.indice === null
                      ? -1
                      : a.indice - b.indice
                  )
                  ?.map((row, ind) =>
                    row.active ? (
                      <div
                        className="sidebar-internal-container-menus-attributes-individual"
                        style={
                          isSelected === row.name
                            ? {
                                backgroundColor: colors?.main_buttons,
                                color: "#fff",
                              }
                            : {}
                        }
                      >
                        <div
                          style={{
                            marginBottom: "0.625rem",
                            marginTop: ind !== 0 ? "1.25rem" : "0rem",
                          }}
                        >
                          {row.name}
                        </div>
                        {/* {isSelectedAttribute === row.name ? ( */}
                        <div className="sidebar-internal-container-menus-attributes-individual-values">
                          {/* Botón "Ver todos" */}
                          <div
                            className="sidebar-internal-container-menus-attributes-individual-values-button"
                            style={{
                              maxWidth:
                                !window.functionIsPortrait() &&
                                window.functionIsMobileDevice()
                                  ? "3.5625rem"
                                  : "5.2rem",
                              width:
                                !window.functionIsPortrait() &&
                                window.functionIsMobileDevice()
                                  ? "3.5625rem"
                                  : "5.2rem",
                              height:
                                !window.functionIsPortrait() &&
                                window.functionIsMobileDevice()
                                  ? "1.0625rem"
                                  : "1.875rem",
                              maxHeight:
                                !window.functionIsPortrait() &&
                                window.functionIsMobileDevice()
                                  ? "1.0625rem"
                                  : "1.875rem",
                              marginLeft:
                                !window.functionIsPortrait() &&
                                window.functionIsMobileDevice()
                                  ? "0.375rem"
                                  : "0.625rem",
                              backgroundColor:
                                !isSelectedAttribute[row.name] ||
                                isSelectedAttribute[row.name].length === 0
                                  ? colors?.main_buttons
                                  : "",
                              color:
                                !isSelectedAttribute[row.name] ||
                                isSelectedAttribute[row.name].length === 0
                                  ? "#fff"
                                  : "",
                            }}
                            onClick={() => {
                              setIsSelectedAttribute({
                                ...isSelectedAttribute,
                                [row.name]: [], // limpia selección
                              });
                              setCurrentSelectedAttribute([]);
                              setIsAnimationAttribute(true);
                            }}
                          >
                            Ver todos
                          </div>

                          {/* Botones de valores */}
                          {row?.values?.map((subRow, subInd) => {
                            const current = isSelectedAttribute[row.name] || [];
                            const isSelected = current.some((item) =>
                              item?.value
                                ? item.value === subRow.value
                                : item === subRow.value
                            );

                            const isValid = isValidateFilter(subRow, row.name); // ✅ ahora con row.name

                            // Estilos base
                            let style = {
                              backgroundColor: isSelected
                                ? colors?.main_buttons
                                : "",
                              color: isSelected ? "#fff" : "",
                              pointerEvents: isValid ? "auto" : "none",
                              opacity: isValid ? "1" : "0.5",
                              cursor: isValid ? "pointer" : "none",
                            };

                            // Tamaño según longitud del texto
                            const isMobile =
                              !window.functionIsPortrait() &&
                              window.functionIsMobileDevice();
                            if (subRow.value.length < 3) {
                              style = {
                                ...style,
                                maxWidth: isMobile ? "1.5625rem" : "2.3rem",
                                width: isMobile ? "1.5625rem" : "2.3rem",
                                height: isMobile ? "1.0625rem" : "1.875rem",
                                maxHeight: isMobile ? "1.0625rem" : "1.875rem",
                                marginLeft: isMobile ? "0.375rem" : "0.625rem",
                                marginRight:
                                  isMobile && subInd === row?.values?.length
                                    ? "0.375rem !important"
                                    : "",
                              };
                            } else if (subRow.value.length < 12) {
                              style = {
                                ...style,
                                maxWidth: isMobile ? "3.5625rem" : "5.2rem",
                                width: isMobile ? "3.5625rem" : "5.2rem",
                                height: isMobile ? "1.0625rem" : "1.875rem",
                                maxHeight: isMobile ? "1.0625rem" : "1.875rem",
                                marginLeft: isMobile ? "0.375rem" : "0.625rem",
                                marginRight:
                                  isMobile && subInd === row?.values?.length
                                    ? "0.375rem !important"
                                    : "",
                              };
                            } else {
                              style = {
                                ...style,
                                maxWidth: isMobile ? "3.5625rem" : "10.8125rem",
                                width: isMobile ? "3.5625rem" : "10.8125rem",
                                height: isMobile ? "1.0625rem" : "1.875rem",
                                maxHeight: isMobile ? "1.0625rem" : "1.875rem",
                                marginLeft: isMobile ? "0.375rem" : "0.625rem",
                                marginRight:
                                  isMobile && subInd === row?.values?.length
                                    ? "0.375rem !important"
                                    : "",
                              };
                            }

                            return (
                              <div
                                key={subRow.value}
                                className="sidebar-internal-container-menus-attributes-individual-values-button"
                                style={style}
                                data-type="FILTRO"
                                data-value={row.name.toUpperCase()}
                                data-second={subRow.value.toUpperCase()}
                                onClick={() => {
                                  const exists = current.some(
                                    (item) =>
                                      item?.value === subRow.value ||
                                      item === subRow.value
                                  );
                                  setIsSelectedAttribute({
                                    ...isSelectedAttribute,
                                    [row.name]: exists
                                      ? current.filter(
                                          (item) =>
                                            item?.value !== subRow.value &&
                                            item !== subRow.value
                                        ) // toggle off
                                      : [...current, subRow], // add
                                  });
                                  setCurrentSelectedAttribute([subRow]);
                                  setIsAnimationAttribute(true);
                                }}
                              >
                                {subRow.value}
                              </div>
                            );
                          })}
                        </div>

                        {/* ) : null} */}
                      </div>
                    ) : null
                  )}
              </div>
            </>
          ) : menuSelected === "Inmuebles" &&
            subMenuSelected !== "" &&
            subMenuSelected !== "Galería" ? (
            <>
              {data?.properties?.disponibilidad ? (
                <div
                  className={`sidebar-internal-container-menus-availability ${
                    isSelectedModulAttribute.disponibilidad ? "" : "collapse"
                  }`}
                >
                  <div
                    className="sidebar-internal-container-menus-availability-title"
                    onClick={() =>
                      setIsSelectedModulAttribute({
                        ...isSelectedModulAttribute,
                        disponibilidad:
                          !isSelectedModulAttribute.disponibilidad,
                      })
                    }
                  >
                    DISPONIBILIDAD
                    <i
                      style={{
                        transform: isSelectedModulAttribute.disponibilidad
                          ? "rotate(90deg)"
                          : "rotate(0deg)",
                      }}
                      className={`fa fa-chevron-right`}
                    ></i>
                  </div>
                  {isSelectedModulAttribute.disponibilidad ? (
                    <>
                      {data?.state_disponible ? (
                        <div className="sidebar-internal-container-menus-availability-sw">
                          <FormControlLabel
                            control={
                              <SwitchDisponible
                                sx={{ m: 0.5 }}
                                defaultChecked
                              />
                            }
                            label=""
                            style={{ marginLeft: "0.2rem" }}
                            onChange={(e: any) =>
                              setSelectAvailability({
                                ...selectAvailability,
                                DISPONIBLE: e.target.checked,
                              })
                            }
                          />
                          <span>Disponible</span>
                        </div>
                      ) : null}{" "}
                      {data?.state_vendido === 1 ? (
                        <div className="sidebar-internal-container-menus-availability-sw">
                          <FormControlLabel
                            control={
                              <SwitchVendido sx={{ m: 0.5 }} defaultChecked />
                            }
                            label=""
                            style={{ marginLeft: "0.2rem" }}
                            onChange={(e: any) =>
                              setSelectAvailability({
                                ...selectAvailability,
                                VENDIDO: e.target.checked,
                              })
                            }
                          />
                          <span>Vendido</span>
                        </div>
                      ) : null}{" "}
                      {data?.state_no_disponible ? (
                        <div className="sidebar-internal-container-menus-availability-sw">
                          <FormControlLabel
                            control={
                              <SwitchNoDisponible
                                sx={{ m: 0.5 }}
                                defaultChecked
                              />
                            }
                            label=""
                            style={{ marginLeft: "0.2rem" }}
                            onChange={(e: any) =>
                              setSelectAvailability({
                                ...selectAvailability,
                                "NO DISPONIBLE": e.target.checked,
                              })
                            }
                          />
                          <span>No Disponible</span>
                        </div>
                      ) : null}{" "}
                      {data?.state_reservado === 1 ? (
                        <div className="sidebar-internal-container-menus-availability-sw">
                          <FormControlLabel
                            control={
                              <SwitchReservado sx={{ m: 0.5 }} defaultChecked />
                            }
                            label=""
                            style={{ marginLeft: "0.2rem" }}
                            onChange={(e: any) =>
                              setSelectAvailability({
                                ...selectAvailability,
                                RESERVADO: e.target.checked,
                              })
                            }
                          />
                          <span>Reservado</span>
                        </div>
                      ) : null}
                    </>
                  ) : null}
                </div>
              ) : null}
              <div
                className={`sidebar-internal-container-menus-attributes ${
                  isSelectedModulAttribute.filtros ? "" : "collapse"
                }`}
              >
                <div
                  className="sidebar-internal-container-menus-attributes-title"
                  onClick={() =>
                    setIsSelectedModulAttribute({
                      ...isSelectedModulAttribute,
                      filtros: !isSelectedModulAttribute.filtros,
                    })
                  }
                >
                  FILTRAR POR ATRIBUTOS
                  <i
                    style={{
                      transform: isSelectedModulAttribute.filtros
                        ? "rotate(90deg)"
                        : "rotate(0deg)",
                    }}
                    className={`fa fa-chevron-right`}
                  ></i>
                </div>
                {isSelectedModulAttribute.filtros &&
                  memoizedValidations
                    .sort((a, b) =>
                      a.indice === null
                        ? 1
                        : b.indice === null
                        ? -1
                        : a.indice - b.indice
                    )
                    .map(({ row, validations }, ind) =>
                      row.active ? (
                        <div
                          key={row.name}
                          className="sidebar-internal-container-menus-attributes-individual"
                          style={
                            isSelected === row.name
                              ? {
                                  backgroundColor: colors?.main_buttons,
                                  color: "#fff",
                                }
                              : {}
                          }
                        >
                          <div
                            style={{
                              marginBottom: "0.625rem",
                              marginTop: ind !== 0 ? "1.25rem" : "0rem",
                            }}
                          >
                            {row.name}
                          </div>
                          <div className="sidebar-internal-container-menus-attributes-individual-values">
                            {/* Botón "Ver todos" */}
                            <div
                              className="sidebar-internal-container-menus-attributes-individual-values-button"
                              style={{
                                marginLeft: "0.625rem",
                                backgroundColor:
                                  !isSelectedAttribute[row.name] ||
                                  isSelectedAttribute[row.name].length === 0
                                    ? colors?.main_buttons
                                    : "",
                                color:
                                  !isSelectedAttribute[row.name] ||
                                  isSelectedAttribute[row.name].length === 0
                                    ? "#fff"
                                    : "",
                                pointerEvents: !row.values.some((e) =>
                                  Array.isArray(subMenuSelected)
                                    ? subMenuSelected.includes(e.value)
                                    : e.value === subMenuSelected
                                )
                                  ? "auto"
                                  : "none",
                                opacity: !row.values.some((e) =>
                                  Array.isArray(subMenuSelected)
                                    ? subMenuSelected.includes(e.value)
                                    : e.value === subMenuSelected
                                )
                                  ? "1"
                                  : "0.5",
                                cursor: !row.values.some((e) =>
                                  Array.isArray(subMenuSelected)
                                    ? subMenuSelected.includes(e.value)
                                    : e.value === subMenuSelected
                                )
                                  ? "pointer"
                                  : "none",
                              }}
                              onClick={() => {
                                setIsSelectedAttribute({
                                  ...isSelectedAttribute,
                                  [row.name]: [],
                                });
                                setCurrentSelectedAttribute([]);
                                setIsAnimationAttribute(true);
                              }}
                            >
                              Ver todos
                            </div>

                            {/* Lista de validaciones */}
                            {validations.map(
                              ({
                                subRow,
                                subInd,
                                isValidFilter,
                                isValidFilterAttribute,
                              }) => {
                                const current =
                                  isSelectedAttribute[row.name] || [];
                                const exists = current.some((item) =>
                                  item.value
                                    ? item.value === subRow.value
                                    : item === subRow
                                );

                                return (
                                  <div
                                    key={subRow.value}
                                    className="sidebar-internal-container-menus-attributes-individual-values-button"
                                    style={getButtonStyle(
                                      row,
                                      subRow,
                                      subInd,
                                      colors,
                                      isSelectedAttribute,
                                      isValidFilter && isValidFilterAttribute
                                    )}
                                    data-type="FILTRO"
                                    data-value={row.name.toUpperCase()}
                                    data-second={subRow.value.toUpperCase()}
                                    onClick={() => {
                                      setIsSelectedAttribute({
                                        ...isSelectedAttribute,
                                        [row.name]: exists
                                          ? current // si ya existe, no lo agrega (puedes hacer un toggle aquí si quieres)
                                          : [...current, subRow],
                                      });
                                      setCurrentSelectedAttribute([subRow]);
                                      setIsAnimationAttribute(true);
                                    }}
                                  >
                                    {subRow.value}
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                      ) : null
                    )}
              </div>
            </>
          ) : menuSelected === "Amenidades" &&
            (subMenuSelected === "" || subMenuSelected === "Spin") &&
            amenities_hierarchical === 1 ? (
            <>
              <div
                className="sidebar-internal-container-menus-item"
                onClick={() => {
                  setIsSelected("");
                  setSpinSelected([]);
                  setSubMenuSelected("");
                  setIsAnimationAmenites(true);
                  setIsSelectedAmenityAttributeIndividual("");
                  setIsSelectedAmenitiesAttributes([]);
                }}
                style={
                  isSelected === ""
                    ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                      }
                    : {}
                }
              >
                <div
                  style={
                    isSelected === ""
                      ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                      : {}
                  }
                >
                  <img
                    src={icon}
                    alt=""
                    style={
                      isSelected === ""
                        ? {
                            filter: "invert(1) brightness(100%)",
                          }
                        : {}
                    }
                  />{" "}
                  {"Ver todos"}
                </div>
              </div>
              {data?.map((roww) => (
                <div className="sidebar-internal-container-menus-item-attribute">
                  <div
                    ref={(el) => {
                      if (el) attributeRefs.current[roww.attribute_id] = el;
                      else delete attributeRefs.current[roww.attribute_id];
                    }}
                    onClick={() => {
                      setIsSelectedAmenityAttributeIndividual(
                        isSelectedAmenityAttributeIndividual ===
                          roww.attribute_id
                          ? ""
                          : roww.attribute_id
                      ),
                        setIsSelectedAmenitiesAttributes(
                          isSelectedAmenityAttributeIndividual ===
                            roww.attribute_id
                            ? []
                            : roww.amenities
                        );
                    }}
                    style={{ marginBottom: "10px" }}
                  >
                    <img src={icon} alt="" /> {roww.attribute}
                    {roww.amenities.length > 0 ? (
                      <i
                        className={`fa fa-chevron-right`}
                        style={{
                          transform:
                            isSelectedAmenityAttributeIndividual === roww.id
                              ? "rotate(90deg)"
                              : "rotate(0deg)",
                        }}
                      ></i>
                    ) : null}
                  </div>
                  {isSelectedAmenityAttributeIndividual === roww.attribute_id &&
                    roww?.amenities?.map((row) => (
                      <div
                        key={row.id}
                        ref={(el) => {
                          if (el) amenityRefs.current[row.id] = el;
                          else delete amenityRefs.current[row.id];
                        }}
                        className="sidebar-internal-container-menus-item"
                        onClick={() => {
                          setIsSelected(isSelected === row.id ? "" : row.id);
                          setSpinSelected([]);
                          setSubMenuSelected("");
                          setIsAnimationAmenites(true);
                          setIsSelectedAmenitiesAttributes([]);
                        }}
                        style={
                          isSelected === row.id /* &&
                          row.menu.length === 0 &&
                          row.spin === null */
                            ? {
                                backgroundColor: colors?.main_buttons,
                                color: "#fff",
                              }
                            : {}
                        }
                        data-type={"AMENIDADES"}
                        data-value={row.name.toUpperCase()}
                      >
                        <div
                          style={
                            isSelected === row.id /* &&
                            row.menu.length === 0 &&
                            row.spin === null */
                              ? {
                                  backgroundColor: colors?.main_buttons,
                                  color: "#fff",
                                }
                              : {}
                          }
                          data-type={"AMENIDADES"}
                          data-value={row.name.toUpperCase()}
                        >
                          <img
                            src={
                              (window.hybrid
                                ? ""
                                : "https://d1bsymnertnea6.cloudfront.net/") +
                              row.icon
                            }
                            style={
                              isSelected === row.id /* &&
                              row.menu.length === 0 &&
                              row.spin === null */
                                ? {
                                    filter: "invert(1) brightness(100%)",
                                  }
                                : {}
                            }
                            data-type={"AMENIDADES"}
                            data-value={row.name.toUpperCase()}
                            alt=""
                          />{" "}
                          {row.name}
                          {row.menu.length > 0 ||
                          row.spin !== null ||
                          row.view3d === true ? (
                            <i
                              className={`fa fa-chevron-right`}
                              style={{
                                transform:
                                  isSelected === row.id
                                    ? "rotate(90deg)"
                                    : "rotate(0deg)",
                              }}
                            ></i>
                          ) : null}
                        </div>
                        {isSelected === row.id && row.menu.length > 0 ? (
                          <div
                            onClick={(event) => {
                              event.stopPropagation(); // Detener la propagación del evento
                              setGaleriaSelected(row.menu);
                              setSubMenuSelected("Galería");
                              setOriginalGleriaSelected(row.menu);
                              setSpinSelected([]);
                            }}
                            className="sidebar-internal-container-menus-subItem"
                            style={{ marginBottom: "0px" }}
                          >
                            <img src="./UI/general/Galeria.svg" alt="" />
                            Ver galería
                          </div>
                        ) : null}

                        {isSelected === row.id && row.view3d === true ? (
                          <div
                            onClick={(event) => {
                              event.stopPropagation(); // Detener la propagación del evento
                              setIsSelectedAmenitiesView(
                                isSelectedAmenitiesView === row.id ? "" : row.id
                              );
                            }}
                            style={
                              isSelected === row.id &&
                              isSelectedAmenitiesView === row.id
                                ? {
                                    backgroundColor: colors?.main_buttons,
                                    color: "#fff",
                                    marginBottom: "0px",
                                  }
                                : { marginBottom: "0px" }
                            }
                            className="sidebar-internal-container-menus-subItem"
                          >
                            <img src="./UI/general/PDI_black.svg" alt="" />
                            Ver a detalle
                          </div>
                        ) : null}

                        {isSelected === row.id && row.spin !== null ? (
                          <div
                            style={
                              isSelected === row.id &&
                              subMenuSelected === "Spin"
                                ? {
                                    backgroundColor: colors?.main_buttons,
                                    color: "#fff",
                                    marginBottom: "0px",
                                  }
                                : { marginBottom: "0px" }
                            }
                            onClick={(event) => {
                              event.stopPropagation(); // Detener la propagación del evento
                              setSpinSelected(row);
                              setSubMenuSelected("Spin");
                              //setFrame(1);
                            }}
                            className="sidebar-internal-container-menus-subItem"
                          >
                            <img
                              src="./UI/general/Spin180.svg"
                              style={
                                isSelected === row.id &&
                                subMenuSelected === "Spin"
                                  ? {
                                      filter: "invert(1) brightness(100%)",
                                    }
                                  : {}
                              }
                              alt=""
                            />
                            Spin
                          </div>
                        ) : null}
                      </div>
                    ))}
                </div>
              ))}
            </>
          ) : menuSelected === "Amenidades" &&
            (subMenuSelected === "" || subMenuSelected === "Spin") &&
            amenities_hierarchical === 0 ? (
            <>
              <div
                className="sidebar-internal-container-menus-item"
                onClick={() => {
                  setIsSelected("");
                  setSpinSelected([]);
                  setSubMenuSelected("");
                  setIsAnimationAmenites(true);
                }}
                style={
                  isSelected === ""
                    ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                      }
                    : {}
                }
              >
                <div
                  style={
                    isSelected === ""
                      ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                      : {}
                  }
                >
                  <img
                    src={icon}
                    alt=""
                    style={
                      isSelected === ""
                        ? {
                            filter: "invert(1) brightness(100%)",
                          }
                        : {}
                    }
                  />{" "}
                  {"Ver todos"}
                </div>
              </div>
              {data.map((row) => (
                <div
                  ref={(el) => {
                    if (el) amenityRefs.current[row.id] = el;
                    else delete amenityRefs.current[row.id];
                  }}
                  className="sidebar-internal-container-menus-item"
                  onClick={() => {
                    setIsSelected(isSelected === row.id ? "" : row.id);
                    setSpinSelected([]);
                    setSubMenuSelected("");
                    setIsAnimationAmenites(true);
                  }}
                  style={
                    isSelected === row.id /* &&
                    row.menu.length === 0 &&
                    row.spin === null */
                      ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                      : {}
                  }
                  data-type={"AMENIDADES"}
                  data-value={row.name.toUpperCase()}
                >
                  <div
                    style={
                      isSelected === row.id /* &&
                      row.menu.length === 0 &&
                      row.spin === null */
                        ? {
                            backgroundColor: colors?.main_buttons,
                            color: "#fff",
                          }
                        : {}
                    }
                    data-type={"AMENIDADES"}
                    data-value={row.name.toUpperCase()}
                  >
                    <img
                      src={
                        (window.hybrid
                          ? ""
                          : "https://d1bsymnertnea6.cloudfront.net/") + row.icon
                      }
                      style={
                        isSelected === row.id /* &&
                        row.menu.length === 0 &&
                        row.spin === null */
                          ? {
                              filter: "invert(1) brightness(100%)",
                            }
                          : {}
                      }
                      data-type={"AMENIDADES"}
                      data-value={row.name.toUpperCase()}
                      alt=""
                    />{" "}
                    {row.name}
                    {row.view3d === true ||
                    row.menu.length > 0 ||
                    row.spin !== null ? (
                      <i
                        className={`fa fa-chevron-right`}
                        style={{
                          transform:
                            isSelected === row.id
                              ? "rotate(90deg)"
                              : "rotate(0deg)",
                        }}
                      ></i>
                    ) : null}
                  </div>
                  {isSelected === row.id && row.menu.length > 0 ? (
                    <div
                      onClick={(event) => {
                        event.stopPropagation(); // Detener la propagación del evento
                        setGaleriaSelected(row.menu);
                        setSubMenuSelected("Galería");
                        setOriginalGleriaSelected(row.menu);
                        setSpinSelected([]);
                      }}
                      className="sidebar-internal-container-menus-subItem"
                      style={{ marginBottom: "0px" }}
                    >
                      <img src="./UI/general/Galeria.svg" alt="" />
                      Ver galería
                    </div>
                  ) : null}
                  {isSelected === row.id && row.view3d === true ? (
                    <div
                      onClick={(event) => {
                        event.stopPropagation(); // Detener la propagación del evento
                        setIsSelectedAmenitiesView(
                          isSelectedAmenitiesView === row.id ? "" : row.id
                        );
                      }}
                      style={
                        isSelected === row.id &&
                        isSelectedAmenitiesView === row.id
                          ? {
                              backgroundColor: colors?.main_buttons,
                              color: "#fff",
                              marginBottom: "0px",
                            }
                          : { marginBottom: "0px" }
                      }
                      className="sidebar-internal-container-menus-subItem"
                    >
                      <img src="./UI/general/PDI_black.svg" alt="" />
                      Ver a detalle
                    </div>
                  ) : null}

                  {isSelected === row.id && row.spin !== null ? (
                    <div
                      style={
                        isSelected === row.id && subMenuSelected === "Spin"
                          ? {
                              backgroundColor: colors?.main_buttons,
                              color: "#fff",
                              marginBottom: "0px",
                            }
                          : { marginBottom: "0px" }
                      }
                      onClick={(event) => {
                        event.stopPropagation(); // Detener la propagación del evento
                        setSpinSelected(row);
                        setSubMenuSelected("Spin");
                        //setFrame(1);
                      }}
                      className="sidebar-internal-container-menus-subItem"
                    >
                      <img
                        src="./UI/general/Spin180.svg"
                        style={
                          isSelected === row.id && subMenuSelected === "Spin"
                            ? {
                                filter: "invert(1) brightness(100%)",
                              }
                            : {}
                        }
                        alt=""
                      />
                      Spin
                    </div>
                  ) : null}
                </div>
              ))}
            </>
          ) : menuSelected !== "Galería" && subMenuSelected === "Galería" ? (
            original.map((row) => (
              <div
                className="sidebar-internal-container-menus-item"
                onClick={() => {
                  setIsSelected(isSelected === row.name ? "" : row.name);
                  setGaleriaSelected(
                    isSelected === row.name
                      ? original
                      : original?.filter((g) => g.name === row.name)
                  );
                }}
                style={
                  isSelected === row.name
                    ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                      }
                    : {}
                }
              >
                <div>
                  <img src={icon} alt="" /> {row.name}
                </div>
              </div>
            ))
          ) : menuSelected === "Galería" &&
            subMenuSelected !== "Galería" &&
            subMenuSelected !== "" ? (
            original
              .find((o) => o.name === subMenuSelected)
              ?.galleries?.galleries[0]?.map((row) => (
                <div
                  className="sidebar-internal-container-menus-item"
                  onClick={() => {
                    setIsSelected(isSelected === row.name ? "" : row.name);
                    setGaleriaSelected(
                      isSelected === row.name
                        ? original.find((o) => o.name === subMenuSelected)
                            ?.galleries?.galleries[0]
                        : original
                            .find((o) => o.name === subMenuSelected)
                            ?.galleries?.galleries[0]?.filter(
                              (g) => g.name === row.name
                            )
                    );
                  }}
                  style={
                    isSelected === row.name
                      ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                      : {}
                  }
                >
                  <div
                    style={
                      isSelected === row.name
                        ? {
                            backgroundColor: colors?.main_buttons,
                            color: "#fff",
                          }
                        : {}
                    }
                  >
                    <img
                      src={icon}
                      alt=""
                      style={
                        isSelected === row.name
                          ? {
                              filter: "invert(1) brightness(100%)",
                            }
                          : {}
                      }
                    />{" "}
                    {row.name}
                  </div>
                </div>
              ))
          ) : menuSelected === "Galería" && subMenuSelected === "Galería" ? (
            data.map((row: any) =>
              row?.galleries?.galleries.length > 0 ? (
                <div
                  className="sidebar-internal-container-menus-folder"
                  onClick={() => {
                    // setIsSelected(isSelected === row.name ? "" : row.name)
                    setSubMenuSelected(row.name);
                    setGaleriaSelected(
                      data.find((g) => g.name === row.name)?.galleries
                        ?.galleries[0]
                    );
                  }}
                  style={
                    isSelected === row.name
                      ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                      : {}
                  }
                >
                  <div
                    style={
                      isSelected === row.name
                        ? {
                            backgroundColor: colors?.main_buttons,
                            color: "#fff",
                          }
                        : {}
                    }
                  >
                    <img
                      src={
                        row.name === "Proyecto"
                          ? "./UI/menu/urbanismo.svg"
                          : (window.hybrid
                              ? "./"
                              : "https://d1bsymnertnea6.cloudfront.net/") +
                            row.background
                      }
                      alt=""
                    />{" "}
                    {row.name}
                  </div>
                </div>
              ) : null
            )
          ) : null}
        </div>
      </div>
      <div
        className={`side-bar-toggle ${theme} ${menuSelected}`}
        onClick={() => setIsSideBar(!isSideBar)}
      >
        <i
          className={`fa-solid ${
            isSideBar ? "fa-chevron-left" : "fa-chevron-right"
          }`}
        ></i>
      </div>
    </div>
  ) : (
    <div className={`sidebar-container-portrait`}>
      <div
        className={`sidebar-container-portrait-internal ${theme}  ${menuSelected}`}
        style={
          (Array.isArray(data) && data.find((e) => e.id === isSelected))?.id ||
          (original && original.find((e) => e.name === isSelectedGallerieGroup))
            ?.name ||
          isSelectedLocationGroup !== ""
            ? { maxHeight: "14rem" }
            : menuSelected === "Inmuebles" ||
              (menuSelected === "Amenidades" &&
                amenities_hierarchical === 1 &&
                subMenuSelected !== "Galería")
            ? { maxHeight: "17.6875rem" }
            : {}
        }
      >
        <div
          onTouchStart={(e) => {
            setIsDragging(true);
            setStartX(window.innerHeight - e.touches[0].clientY);
            console.log("a", window.innerHeight - e.touches[0].clientY);
          }}
          onTouchMove={(e) => {
            console.log("ac", window.innerHeight - e.touches[0].clientY);

            var sidebarOriginal: any = document.querySelector(
              ".sidebar-container-portrait"
            );
            var sidebarInternal: any = document.querySelector(
              ".sidebar-container-portrait-internal"
            );
            console.log(sidebarInternal.offsetHeight);

            if (isDragging) {
              const diffX = window.innerHeight - e.touches[0].clientY;
              console.log(isSideBar);

              if (isSideBar) {
                if (diffX <= startX && diffX >= 14) {
                  const newWidth = diffX - sidebarInternal.offsetHeight;
                  sidebarOriginal.style.bottom = `${newWidth}px`;
                  setStartX(window.innerHeight - e.touches[0].clientY);
                  setStartXOther(window.innerHeight - e.touches[0].clientY);
                }
              } else {
                if (diffX >= startX && diffX <= sidebarInternal.offsetHeight) {
                  const newWidth = diffX - sidebarInternal.offsetHeight;
                  sidebarOriginal.style.bottom = `${newWidth}px`;
                  setStartX(window.innerHeight - e.touches[0].clientY);
                  setStartXOther(window.innerHeight - e.touches[0].clientY);
                }
              }
            }
          }}
          onTouchEnd={(e) => {
            var sidebarInternal: any = document.querySelector(
              ".sidebar-container-portrait-internal"
            );
            console.log();

            if (startXOther !== null) {
              if (startX < sidebarInternal.offsetHeight / 2) {
                setIsSideBar(false);
                handleAddDown(false);
                setStartXOther(null);
              } else {
                setIsSideBar(true);
                handleAddDown(true);
                setStartXOther(null);
              }
            }
          }}
        >
          <div
            className={`sidebar-toggle-internal ${theme}`}
            //onClick={() => setIsSideBar(!isSideBar)}
            onTouchStart={(e) => {
              setIsDragging(true);
              setStartX(window.innerHeight - e.touches[0].clientY);
              console.log("a", window.innerHeight - e.touches[0].clientY);
            }}
            onTouchMove={(e) => {
              console.log("ac", window.innerHeight - e.touches[0].clientY);

              var sidebarOriginal: any = document.querySelector(
                ".sidebar-container-portrait"
              );
              var sidebarInternal: any = document.querySelector(
                ".sidebar-container-portrait-internal"
              );
              console.log(sidebarInternal.offsetHeight);

              if (isDragging) {
                const diffX = window.innerHeight - e.touches[0].clientY;
                console.log(isSideBar);

                if (isSideBar) {
                  if (diffX <= startX && diffX >= 14) {
                    const newWidth = diffX - sidebarInternal.offsetHeight;
                    sidebarOriginal.style.bottom = `${newWidth}px`;
                    setStartX(window.innerHeight - e.touches[0].clientY);
                    setStartXOther(window.innerHeight - e.touches[0].clientY);
                  }
                } else {
                  if (
                    diffX >= startX &&
                    diffX <= sidebarInternal.offsetHeight
                  ) {
                    const newWidth = diffX - sidebarInternal.offsetHeight;
                    sidebarOriginal.style.bottom = `${newWidth}px`;
                    setStartX(window.innerHeight - e.touches[0].clientY);
                    setStartXOther(window.innerHeight - e.touches[0].clientY);
                  }
                }
              }
            }}
            onTouchEnd={(e) => {
              var sidebarInternal: any = document.querySelector(
                ".sidebar-container-portrait-internal"
              );
              console.log();

              if (startXOther !== null) {
                if (startX < sidebarInternal.offsetHeight / 2) {
                  setIsSideBar(false);
                  handleAddDown(false);
                  setStartXOther(null);
                } else {
                  setIsSideBar(true);
                  handleAddDown(true);
                  setStartXOther(null);
                }
              }
            }}
          ></div>
        </div>
        <div className="sidebar-title-internal-portrait">
          <img src={icono} alt="" />
          {menuSelected !== "Galería" && subMenuSelected === "Galería"
            ? subMenuSelected
            : menuSelected}
        </div>
        <div className={`sidebar-menu-container-portrait ${theme}`}>
          {menuSelected === "Urbanismo" && subMenuSelected === "" ? (
            data
              .sort((a, b) =>
                !a.hierarchicalLevel
                  ? 1
                  : !b.hierarchicalLevel
                  ? -1
                  : parseInt(b.hierarchicalLevel.split("#")[1]) -
                    parseInt(a.hierarchicalLevel.split("#")[1])
              )
              .map((row) =>
                row.type === "Hierarchical" ? (
                  <div
                    className="sidebar-menu-container-portrait-menus-item"
                    onClick={() =>
                      setIsSelected(isSelected === row.name ? "" : row.name)
                    }
                    style={
                      isSelected === row.name
                        ? {
                            backgroundColor: colors?.main_buttons,
                            color: "#fff",
                          }
                        : {}
                    }
                  >
                    <div>
                      <img src={icon} alt="" /> {row.name}
                    </div>
                  </div>
                ) : null
              )
          ) : menuSelected === "Ubicación" ? (
            <>
              {data?.routes?.length > 0 ||
              data?.mapa_ilustrado_vias !== null ? (
                <div
                  className="sidebar-menu-container-portrait-menus-item"
                  onClick={() => {
                    setIsSelectedLocationGroup(
                      isSelectedLocationGroup === "vias" ? "" : "vias"
                    );

                    setisMapRenderVIAS(false);
                    setIsMapFoto360POIS(false);
                  }}
                  style={
                    isSelectedLocationGroup === "vias"
                      ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                      : {}
                  }
                >
                  <div>
                    <img src={VIA} alt="" /> Vías de Acceso
                  </div>
                </div>
              ) : null}
              {data?.POIS?.length > 0 || data?.mapa_ilustrado_pois !== null ? (
                <div
                  className="sidebar-menu-container-portrait-menus-item"
                  onClick={() => {
                    setIsSelectedLocationGroup(
                      isSelectedLocationGroup === "poi" ? "" : "poi"
                    );

                    setisMapRenderVIAS(false);
                    setIsMapFoto360POIS(false);
                  }}
                  style={
                    isSelectedLocationGroup === "poi"
                      ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }
                      : {}
                  }
                >
                  <div>
                    <img src={POI} alt="" /> Puntos de interés
                  </div>
                </div>
              ) : null}
            </>
          ) : menuSelected === "Amenidades" &&
            subMenuSelected !== "Galería" &&
            amenities_hierarchical === 0 ? (
            <>
              <div
                className="sidebar-menu-container-portrait-menus-item"
                onClick={() => setIsSelected("")}
                style={
                  isSelected === ""
                    ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                        width: "5.2rem",
                        minWidth: "5.2rem",
                      }
                    : {
                        width: "5.2rem",
                        minWidth: "5.2rem",
                      }
                }
              >
                <div>{"Ver todos"}</div>
              </div>
              {data.map((row) => (
                <div
                  className="sidebar-menu-container-portrait-menus-item"
                  onClick={() => {
                    setIsSelected(isSelected === row.id ? "" : row.id);
                    setSpinSelected([]);
                    setSubMenuSelected("");
                    setIsAnimationAmenites(true);
                  }}
                  style={
                    isSelected === row?.id
                      ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                          width:
                            row.name.length <= 10
                              ? "7.75rem"
                              : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                              ? "13.375rem"
                              : "5.2rem",
                          minWidth:
                            row.name.length <= 10
                              ? "7.75rem"
                              : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                              ? "13.375rem"
                              : "5.2rem",
                        }
                      : {
                          width:
                            row.name.length <= 10
                              ? "7.75rem"
                              : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                              ? "13.375rem"
                              : "5.2rem",
                          minWidth:
                            row.name.length <= 10
                              ? "7.75rem"
                              : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                              ? "13.375rem"
                              : "5.2rem",
                        }
                  }
                  data-type={"AMENIDADES"}
                  data-value={row.name.toUpperCase()}
                >
                  <div
                    data-type={"AMENIDADES"}
                    data-value={row.name.toUpperCase()}
                  >
                    <img
                      src={
                        (window.hybrid
                          ? "./"
                          : "https://d1bsymnertnea6.cloudfront.net/") + row.icon
                      }
                      alt=""
                      data-type={"AMENIDADES"}
                      data-value={row.name.toUpperCase()}
                    />{" "}
                    {row.name}
                    {/* {row.menu.length > 0 ? (
                      <i
                        className={`fa fa-chevron-${
                          isSelected === row.id ? "down" : "right"
                        }`}
                      ></i>
                    ) : null} */}
                  </div>
                </div>
              ))}
            </>
          ) : menuSelected === "Amenidades" &&
            subMenuSelected !== "Galería" &&
            amenities_hierarchical === 1 ? (
            <>
              <div
                className="sidebar-menu-container-portrait-menus-item"
                onClick={() => {
                  setIsSelected(""),
                    setIsSelectedAmenitiesAttributes([]),
                    setIsSelectedAmenityAttributeIndividual("");
                }}
                style={
                  isSelected === ""
                    ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                        width: "5.2rem",
                        minWidth: "5.2rem",
                      }
                    : {
                        width: "5.2rem",
                        minWidth: "5.2rem",
                      }
                }
              >
                <div>{"Ver todos"}</div>
              </div>
              {data.map((row) => (
                <div
                  className="sidebar-menu-container-portrait-menus-item"
                  onClick={() => {
                    setIsSelectedAmenityAttributeIndividual(
                      isSelectedAmenityAttributeIndividual === row.attribute_id
                        ? ""
                        : row.attribute_id
                    );
                    setSpinSelected([]);
                    setSubMenuSelected("");
                    setIsAnimationAmenites(true);
                    setIsSelectedAmenitiesAttributes(row.amenities);
                  }}
                  style={
                    isSelectedAmenityAttributeIndividual === row?.attribute_id
                      ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                          width:
                            row.attribute.length <= 10
                              ? "7.75rem"
                              : row.attribute.length > 10 &&
                                row.attribute.length < 18
                              ? "10.75rem"
                              : row.attribute.length > 18
                              ? "13.375rem"
                              : "5.2rem",
                          minWidth:
                            row.attribute.length <= 10
                              ? "7.75rem"
                              : row.attribute.length > 10 &&
                                row.attribute.length < 18
                              ? "10.75rem"
                              : row.attribute.length > 18
                              ? "13.375rem"
                              : "5.2rem",
                        }
                      : {
                          width:
                            row.attribute.length <= 10
                              ? "7.75rem"
                              : row.attribute.length > 10 &&
                                row.attribute.length < 18
                              ? "10.75rem"
                              : row.attribute.length > 18
                              ? "13.375rem"
                              : "5.2rem",
                          minWidth:
                            row.attribute.length <= 10
                              ? "7.75rem"
                              : row.attribute.length > 10 &&
                                row.attribute.length < 18
                              ? "10.75rem"
                              : row.attribute.length > 18
                              ? "13.375rem"
                              : "5.2rem",
                        }
                  }
                >
                  <div>{row.attribute}</div>
                </div>
              ))}
            </>
          ) : menuSelected === "Galería" && subMenuSelected === "Galería" ? (
            data.map((row) =>
              row?.galleries?.galleries.length > 0 ? (
                <div
                  className="sidebar-menu-container-portrait-menus-item"
                  onClick={() => {
                    setIsSelectedGallerieGroup(
                      isSelectedGallerieGroup === row.name ? "" : row.name
                    );
                    setSubMenuSelected(row.name);
                    setGaleriaSelected(
                      data.find((g) => g.name === row.name)?.galleries
                        ?.galleries[0]
                    );
                  }}
                  style={
                    isSelectedGallerieGroup === row?.name
                      ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                          width: "6.25rem",
                          maxWidth: "6.25rem",
                          minWidth: "6.25rem",
                          height: "1.875rem",
                        }
                      : {
                          width: "6.25rem",
                          minWidth: "6.25rem",
                          maxWidth: "6.25rem",
                          height: "1.875rem",
                        }
                  }
                >
                  <div>{row.name}</div>
                </div>
              ) : null
            )
          ) : null}
        </div>
        <div className={`sidebar-menu-container-portrait ${theme}`}>
          {menuSelected === "Amenidades" &&
          subMenuSelected !== "Galería" &&
          amenities_hierarchical === 1 &&
          isSelectedAmenityAttributeIndividual !== "" ? (
            <>
              <div
                className="sidebar-menu-container-portrait-menus-item"
                onClick={() => setIsSelected("")}
                style={
                  isSelected === ""
                    ? {
                        backgroundColor: colors?.main_buttons,
                        color: "#fff",
                        width: "5.2rem",
                        minWidth: "5.2rem",
                      }
                    : {
                        width: "5.2rem",
                        minWidth: "5.2rem",
                      }
                }
              >
                <div>{"Ver todos"}</div>
              </div>
              {isSelectedAmenitiesAttributes.map((row) => (
                <div
                  className="sidebar-menu-container-portrait-menus-item"
                  onClick={() => {
                    setIsSelected(isSelected === row.id ? "" : row.id);
                    setSpinSelected([]);
                    setSubMenuSelected("");
                    setIsAnimationAmenites(true);
                  }}
                  style={
                    isSelected === row?.id
                      ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                          width:
                            row.name.length <= 10
                              ? "7.75rem"
                              : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                              ? "13.375rem"
                              : "5.2rem",
                          minWidth:
                            row.name.length <= 10
                              ? "7.75rem"
                              : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                              ? "13.375rem"
                              : "5.2rem",
                        }
                      : {
                          width:
                            row.name.length <= 10
                              ? "7.75rem"
                              : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                              ? "13.375rem"
                              : "5.2rem",
                          minWidth:
                            row.name.length <= 10
                              ? "7.75rem"
                              : row.name.length > 10 && row.name.length < 18
                              ? "10.75rem"
                              : row.name.length > 18
                              ? "13.375rem"
                              : "5.2rem",
                        }
                  }
                  data-type={"AMENIDADES"}
                  data-value={row.name.toUpperCase()}
                >
                  <div
                    data-type={"AMENIDADES"}
                    data-value={row.name.toUpperCase()}
                  >
                    <img
                      src={
                        (window.hybrid
                          ? "./"
                          : "https://d1bsymnertnea6.cloudfront.net/") + row.icon
                      }
                      alt=""
                      data-type={"AMENIDADES"}
                      data-value={row.name.toUpperCase()}
                    />{" "}
                    {row.name}
                    {/* {row.menu.length > 0 ? (
                      <i
                        className={`fa fa-chevron-${
                          isSelected === row.id ? "down" : "right"
                        }`}
                      ></i>
                    ) : null} */}
                  </div>
                </div>
              ))}
            </>
          ) : null}
        </div>
        <div className={`sidebar-menu-container-portrait ${theme}`}>
          {menuSelected === "Amenidades" &&
          subMenuSelected === "" &&
          isSelected !== "" &&
          data.find((e) => e.id === isSelected)?.menu?.length > 0 ? (
            <div
              className="sidebar-menu-container-portrait-menus-item"
              onClick={(event) => {
                event.stopPropagation(); // Detener la propagación del evento
                setGaleriaSelected(data.find((e) => e.id === isSelected)?.menu);
                setSubMenuSelected("Galería");
                setOriginalGleriaSelected(
                  data.find((e) => e.id === isSelected)?.menu
                );
                setSpinSelected([]);
              }}
              /* style={
              isSelected === data.find((e) => e.id === isSelected)?.id
                ? {
                    backgroundColor: colors?.main_buttons,
                    color: "#fff",
                  }
                : {}
            } */
            >
              <div>
                <img src={icon} alt="" /> {"Ver galería"}
              </div>
            </div>
          ) : null}{" "}
          {menuSelected === "Amenidades" &&
          subMenuSelected === "" &&
          isSelected !== "" &&
          data.find((e) => e.id === isSelected && e.view3d === true) ? (
            <div
              //isSelected === row.id && isSelectedAmenitiesView === row.id
              className="sidebar-menu-container-portrait-menus-item"
              style={
                isSelected === data.find((e) => e.id === isSelected)?.id &&
                isSelectedAmenitiesView ===
                  data.find((e) => e.id === isSelected)?.id
                  ? {
                      backgroundColor: colors?.main_buttons,
                      color: "#fff",
                    }
                  : {}
              }
              onClick={(event) => {
                event.stopPropagation();
                const row = data.find((e) => e.id === isSelected);
                setIsSelectedAmenitiesView(
                  isSelectedAmenitiesView === row.id ? "" : row.id
                );
              }}
            >
              <div>
                <img src="./UI/general/PDI_black.svg" alt="" />{" "}
                {"Ver a detalle"}
              </div>
            </div>
          ) : null}{" "}
          {menuSelected === "Amenidades" &&
          //subMenuSelected !== "" &&
          isSelected !== "" &&
          data.find((e) => e.id === isSelected)?.spin !== null ? (
            <div
              className="sidebar-menu-container-portrait-menus-item"
              style={
                isSelected === data.find((e) => e.id === isSelected)?.id &&
                subMenuSelected === "Spin"
                  ? {
                      backgroundColor: colors?.main_buttons,
                      color: "#fff",
                    }
                  : {}
              }
              onClick={(event) => {
                event.stopPropagation(); // Detener la propagación del evento
                const row = data.find((e) => e.id === isSelected);
                setSpinSelected(row);
                setSubMenuSelected("Spin");
                //setFrame(1);
              }}
            >
              <div>
                <img src={icon} alt="" /> {"Spin"}
              </div>
            </div>
          ) : null}
        </div>
        {menuSelected === "Galería" &&
        subMenuSelected !== "" &&
        isSelectedGallerieGroup !== "" &&
        data?.length > 0 ? (
          <>
            <div className={`sidebar-menu-container-portrait ${theme}`}>
              {original.map((row) => (
                <div
                  className="sidebar-menu-container-portrait-menus-item"
                  onClick={() => {
                    setIsSelectedGallerieGroup(
                      isSelectedGallerieGroup === row?.name ? "" : row?.name
                    );
                    setSubMenuSelected(
                      isSelectedGallerieGroup === row?.name
                        ? "Galería"
                        : row?.name
                    );
                    setIsSelected("");
                    setGaleriaSelected(
                      isSelectedGallerieGroup === row?.name
                        ? original
                        : original.find((g) => g.name === row?.name)?.galleries
                            ?.galleries[0]
                    );
                  }}
                  style={
                    isSelectedGallerieGroup === row?.name
                      ? {
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                          width: "6.25rem",
                          maxWidth: "6.25rem",
                          minWidth: "6.25rem",
                          height: "1.875rem",
                        }
                      : {
                          width: "6.25rem",
                          minWidth: "6.25rem",
                          maxWidth: "6.25rem",
                          height: "1.875rem",
                        }
                  }
                >
                  <div>{row?.name}</div>
                </div>
              ))}
            </div>
            <div className={`sidebar-menu-container-portrait ${theme}`}>
              {original
                .find((g) => g.name === isSelectedGallerieGroup)
                ?.galleries?.galleries[0].map((row) => (
                  <div
                    className="sidebar-menu-container-portrait-menus-item"
                    onClick={() => {
                      setIsSelected(isSelected === row.name ? "" : row.name);
                      setGaleriaSelected(
                        isSelected === row.name
                          ? original.find((o) => o.name === subMenuSelected)
                              ?.galleries?.galleries[0]
                          : original
                              .find((o) => o.name === subMenuSelected)
                              ?.galleries?.galleries[0]?.filter(
                                (g) => g.name === row.name
                              )
                      );
                    }}
                    style={
                      isSelected === row?.name
                        ? {
                            backgroundColor: colors?.main_buttons,
                            color: "#fff",
                            width: "6.25rem",
                            maxWidth: "6.25rem",
                            minWidth: "6.25rem",
                            height: "1.875rem",
                          }
                        : {
                            width: "6.25rem",
                            minWidth: "6.25rem",
                            maxWidth: "6.25rem",
                            height: "1.875rem",
                          }
                    }
                  >
                    <div>{row.name}</div>
                  </div>
                ))}
            </div>
          </>
        ) : null}{" "}
        {menuSelected === "Ubicación" && isSelectedLocationGroup !== "" ? (
          <div className="sidebar-menu-container-location-portrait">
            {isSelectedLocationGroup === "vias" ? (
              <>
                <div
                  className="sidebar-menu-container-location-portrait-container-item"
                  style={{ marginBottom: "0.625rem" }}
                >
                  {data?.mapa_ilustrado_vias !== null ? (
                    <div
                      className="sidebar-menu-container-location-portrait-item"
                      style={
                        isMapRenderVIAS
                          ? {
                              backgroundColor: colors?.main_buttons,
                              color: "#fff",
                            }
                          : {}
                      }
                      onClick={() => {
                        setisMapRenderVIAS(!isMapRenderVIAS),
                          setIsMapFoto360POIS(false),
                          setIsSelectedVIA([]),
                          setIsSelectedPOI([]);
                      }}
                    >
                      <img
                        src={IIMG}
                        style={
                          isMapRenderVIAS
                            ? {
                                filter: `invert(1) brightness(100%)`,
                              }
                            : {}
                        }
                        alt=""
                      />
                      <span>Mapa ilustrado</span>
                    </div>
                  ) : null}
                  {data?.mapa_vias_foto_360 !== null ? (
                    <div
                      className="sidebar-menu-container-location-portrait-item"
                      style={
                        isMapFoto360POIS
                          ? {
                              backgroundColor: colors?.main_buttons,
                              color: "#fff",
                            }
                          : {}
                      }
                      onClick={() => {
                        setisMapRenderVIAS(false),
                          setIsMapFoto360POIS(!isMapFoto360POIS),
                          setIsSelectedVIA([]),
                          setIsSelectedPOI([]);
                      }}
                    >
                      <img
                        src={WORLD}
                        style={
                          isMapFoto360POIS
                            ? {
                                filter: `invert(1) brightness(100%)`,
                              }
                            : {}
                        }
                        alt=""
                      />
                      <span>Foto aérea 360°</span>
                    </div>
                  ) : null}
                </div>

                <div className="sidebar-menu-container-location-portrait-container-item">
                  {data?.routes?.length > 0
                    ? data?.routes?.map((e) => (
                        <div
                          className="sidebar-menu-container-location-portrait-item"
                          style={
                            isSelectedVIA.length === 1 &&
                            isSelectedVIA[0]?.name === e.name
                              ? { backgroundColor: colors?.main_buttons }
                              : {}
                          }
                          data-type={"UBICACION"}
                          data-value={"VIA"}
                          data-second={e.name.toUpperCase()}
                          onClick={() => {
                            setIsSelectedVIA([e]);
                            setIsSelectedPOI([]);
                            setisMapRenderVIAS(false);
                            setIsMapFoto360POIS(false);
                          }}
                        >
                          <div style={{ backgroundColor: e.color }}></div>
                          <span>{e.name}</span>
                        </div>
                      ))
                    : null}
                </div>
              </>
            ) : isSelectedLocationGroup === "poi" ? (
              <>
                <div
                  className="sidebar-menu-container-location-portrait-container-item"
                  style={{ marginBottom: "0.625rem" }}
                >
                  {data?.mapa_ilustrado_pois !== null ? (
                    <div
                      className="sidebar-menu-container-location-portrait-item"
                      style={
                        isMapRenderVIAS
                          ? {
                              backgroundColor: colors?.main_buttons,
                              color: "#fff",
                            }
                          : {}
                      }
                      onClick={() => {
                        setisMapRenderVIAS(!isMapRenderVIAS),
                          setIsMapFoto360POIS(false),
                          setIsSelectedVIA([]),
                          setIsSelectedPOI([]);
                      }}
                    >
                      <img
                        src={IIMG}
                        style={
                          isMapRenderVIAS
                            ? {
                                filter: `invert(1) brightness(100%)`,
                              }
                            : {}
                        }
                        alt=""
                      />
                      <span>Mapa ilustrado</span>
                    </div>
                  ) : null}
                  {data?.mapa_pois_foto_360 !== null ? (
                    <div
                      className="sidebar-menu-container-location-portrait-item"
                      style={
                        isMapFoto360POIS
                          ? {
                              backgroundColor: colors?.main_buttons,
                              color: "#fff",
                            }
                          : {}
                      }
                      onClick={() => {
                        setisMapRenderVIAS(false),
                          setIsMapFoto360POIS(!isMapFoto360POIS),
                          setIsSelectedVIA([]),
                          setIsSelectedPOI([]);
                      }}
                    >
                      <img
                        src={WORLD}
                        style={
                          isMapFoto360POIS
                            ? {
                                filter: `invert(1) brightness(100%)`,
                              }
                            : {}
                        }
                        alt=""
                      />
                      <span>Foto aérea 360°</span>
                    </div>
                  ) : null}
                </div>
                <div className="sidebar-menu-container-location-portrait-container-item">
                  {data?.POIS?.length > 0
                    ? data?.POIS?.map((e) => (
                        <div
                          className="sidebar-menu-container-location-portrait-item"
                          style={
                            isSelectedPOI.length === 1 &&
                            isSelectedPOI[0]?.category === e.category
                              ? { backgroundColor: colors?.main_buttons }
                              : {}
                          }
                          data-type={"UBICACION"}
                          data-value={"POI"}
                          data-second={e.category.toUpperCase()}
                          onClick={() => {
                            setIsSelectedPOI([e]);
                            setIsSelectedVIA([]);
                            setisMapRenderVIAS(false);
                            setIsMapFoto360POIS(false);
                          }}
                        >
                          <img
                            style={
                              isSelectedPOI.length === 1 &&
                              isSelectedPOI[0]?.category === e.category
                                ? { filter: "invert(1) brightness(100%)" }
                                : { filter: "invert(1) brightness(100%)" }
                            }
                            src={
                              (window.hybrid
                                ? "./"
                                : "https://d1bsymnertnea6.cloudfront.net/") +
                              e.icon
                            }
                            alt=""
                          />
                          <span>{e.category}</span>
                        </div>
                      ))
                    : null}
                </div>
              </>
            ) : null}
          </div>
        ) : null}
        {menuSelected === "Inmuebles" &&
        subMenuSelected !== "Galería" &&
        data?.properties?.disponibilidad ? (
          <div className="sidebar-menu-container-property-portrait">
            <div
              className="sidebar-menu-container-property-portrait-title"
              onClick={() =>
                setIsSelectedModulAttribute({
                  ...isSelectedModulAttribute,
                  disponibilidad: !isSelectedModulAttribute.disponibilidad,
                })
              }
            >
              DISPONIBILIDAD
              <i
                className={`fa fa-chevron-${
                  isSelectedModulAttribute.disponibilidad ? "down" : "right"
                }`}
              ></i>
            </div>
            {isSelectedModulAttribute.disponibilidad ? (
              <div className="sidebar-menu-container-property-portrait-container-item">
                {data?.state_disponible ? (
                  <div className="sidebar-menu-container-property-portrait-item-availability">
                    <span>Disponible</span>
                    <FormControlLabel
                      control={
                        <SwitchDisponible sx={{ m: 1 }} defaultChecked />
                      }
                      label=""
                      onChange={(e: any) =>
                        setSelectAvailability({
                          ...selectAvailability,
                          DISPONIBLE: e.target.checked,
                        })
                      }
                    />
                  </div>
                ) : null}

                {data?.state_disponible ? (
                  <div className="sidebar-menu-container-property-portrait-item-availability">
                    <span>Vendido</span>
                    <FormControlLabel
                      control={<SwitchVendido sx={{ m: 1 }} defaultChecked />}
                      label=""
                      onChange={(e: any) =>
                        setSelectAvailability({
                          ...selectAvailability,
                          VENDIDO: e.target.checked,
                        })
                      }
                    />
                  </div>
                ) : null}

                {data?.state_disponible ? (
                  <div className="sidebar-menu-container-property-portrait-item-availability">
                    <span>Reservado</span>
                    <FormControlLabel
                      control={<SwitchReservado sx={{ m: 1 }} defaultChecked />}
                      label=""
                      onChange={(e: any) =>
                        setSelectAvailability({
                          ...selectAvailability,
                          RESERVADO: e.target.checked,
                        })
                      }
                    />
                  </div>
                ) : null}

                {data?.state_disponible ? (
                  <div className="sidebar-menu-container-property-portrait-item-availability">
                    <span>No Disponible</span>
                    <FormControlLabel
                      control={
                        <SwitchNoDisponible sx={{ m: 1 }} defaultChecked />
                      }
                      label=""
                      onChange={(e: any) =>
                        setSelectAvailability({
                          ...selectAvailability,
                          "NO DISPONIBLE": e.target.checked,
                        })
                      }
                    />
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
        ) : null}
        {menuSelected === "Inmuebles" && subMenuSelected === "" ? (
          <div className="sidebar-menu-container-property-portrait">
            <div
              className="sidebar-menu-container-property-portrait-title"
              onClick={() =>
                setIsSelectedModulAttribute({
                  ...isSelectedModulAttribute,
                  filtros: !isSelectedModulAttribute.filtros,
                })
              }
            >
              FILTRAR POR ATRIBUTOS
              <i
                className={`fa fa-chevron-${
                  isSelectedModulAttribute.disponibilidad ? "down" : "right"
                }`}
              ></i>
            </div>
            {isSelectedModulAttribute.filtros ? (
              <div className="sidebar-menu-container-property-portrait-container-item">
                {data?.properties?.attributes?.map((row, ind) =>
                  row.active ? (
                    <div
                      key={row.name}
                      className="sidebar-menu-container-property-portrait-item-filter"
                    >
                      <span>{row.name}</span>
                      <select
                        name={`filter-${row.name}`}
                        id={`filter-${row.name}`}
                        style={{
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }}
                        onChange={(e) => {
                          if (e.target.value === "Ver todos") {
                            setIsSelectedAttribute({
                              ...isSelectedAttribute,
                              [row.name]: [], // array vacío
                            });
                            setCurrentSelectedAttribute([]);
                            setIsAnimationAttribute(true);
                          } else {
                            const selectedValue = JSON.parse(e.target.value);
                            setIsSelectedAttribute({
                              ...isSelectedAttribute,
                              [row.name]: [selectedValue], // guardamos como array
                            });
                            setCurrentSelectedAttribute([selectedValue]);
                            setIsAnimationAttribute(true);
                          }
                        }}
                      >
                        <option value="Ver todos">Ver todos</option>
                        {row?.values?.map((subRow) =>
                          isValidateFilter(subRow, row.name) ? ( // ✅ ahora con row.name
                            <option
                              key={subRow.value}
                              value={JSON.stringify(subRow)}
                              data-type="FILTRO"
                              data-second={row.name}
                              data-value={subRow.value.toUpperCase()}
                            >
                              {subRow.value}
                            </option>
                          ) : null
                        )}
                      </select>
                    </div>
                  ) : null
                )}
              </div>
            ) : null}
          </div>
        ) : null}
        {menuSelected === "Inmuebles" &&
        subMenuSelected !== "" &&
        subMenuSelected !== "Galería" ? (
          <div className="sidebar-menu-container-property-portrait">
            <div
              className="sidebar-menu-container-property-portrait-title"
              onClick={() =>
                setIsSelectedModulAttribute({
                  ...isSelectedModulAttribute,
                  filtros: !isSelectedModulAttribute.filtros,
                })
              }
            >
              FILTRAR POR ATRIBUTOS
              <i
                className={`fa fa-chevron-${
                  isSelectedModulAttribute.disponibilidad ? "down" : "right"
                }`}
              ></i>
            </div>
            {isSelectedModulAttribute.filtros ? (
              <div className="sidebar-menu-container-property-portrait-container-item">
                {data?.properties?.attributes?.map((row, ind) =>
                  row.active ? (
                    <div className="sidebar-menu-container-property-portrait-item-filter">
                      <span>{row.name}</span>
                      <select
                        name="cars"
                        id="cars"
                        style={{
                          backgroundColor: colors?.main_buttons,
                          color: "#fff",
                        }}
                        onChange={(e) => {
                          if (e.target.value === "Ver todos") {
                            setIsSelectedAttribute({
                              ...isSelectedAttribute,
                              [row.name]: [],
                            });
                            setCurrentSelectedAttribute({});
                            setIsAnimationAttribute(true);
                          } else {
                            setIsSelectedAttribute({
                              ...isSelectedAttribute,
                              [row.name]: [JSON.parse(e.target.value)],
                            });
                            setCurrentSelectedAttribute(
                              JSON.parse(e.target.value)
                            );
                            setIsAnimationAttribute(true);
                          }
                        }}
                      >
                        <option value="Ver todos">Ver todos</option>
                        {row?.values?.map((subRow, subInd) =>
                          isValidateFilter(subRow, row.name) ? ( // ✅ pasamos row.name
                            <option
                              key={subRow.value} // para evitar warning de React
                              value={JSON.stringify(subRow)}
                              data-type="FILTRO"
                              data-second={row.name}
                              data-value={subRow.value.toUpperCase()}
                            >
                              {subRow.value}
                            </option>
                          ) : null
                        )}
                      </select>
                    </div>
                  ) : null
                )}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
      <div className={`sidebar-container-portrait-close  ${theme}`}>
        <div
          className="setting-boton-circular"
          onClick={() => {
            if (menuSelected === "Inmuebles" && subMenuSelected === "Galería") {
              setSubMenuSelected(subMenuSelectedTemp);
            } else if (
              menuSelected !== "Galería" &&
              menuSelected !== "Inmuebles" &&
              subMenuSelected === "Galería"
            ) {
              setSubMenuSelected("");
            } else {
              setMenuSelected("");
            }

            setSubMenuSelected("");
            setGaleriaSelected([]);
            // setFrame(1);
          }}
        >
          <i className="fas fa-xmark"></i>
        </div>
      </div>
    </div>
  );
}
